module.exports = __webpack_public_path__ + "img/img6.d19c8c0c.png";